<script setup lang="ts">
import { ButtonText } from '@hobbii/hobbii-ui';

import ImageParty from '@/images/user-reviews/party.png';
import { useTranslations } from '@/shared/composables/useTranslations';
const { t } = useTranslations();
import { computed } from 'vue';

import Modal from '@/shared/components/UI/Modal.vue';

const { active } = defineProps<{
  active: boolean;
}>();

const emit = defineEmits(['update:active']);
const propModel = computed({
  get: () => active,
  set: (value) => {
    emit('update:active', value);
  }
});
</script>
<template>
  <Modal v-model:active="propModel" size="md">
    <div class="relative px-6 pt-10 text-center">
      <h2 class="text-3xl font-bold text-green">
        {{ t('reviews.thank_you_title') }}
      </h2>
      <p class="mt-4 text-sm leading-tight text-black">
        {{ t('reviews.thank_you_message') }}
      </p>

      <ButtonText
        size="md"
        theme="primary"
        :full-width="true"
        class="relative z-10 mt-6"
        @click="emit('update:active', false)"
      >
        {{ t('reviews.thank_you_close_button') }}
      </ButtonText>

      <div
        class="absolute bottom-0 left-0 h-32 w-full bg-gradient-to-t from-[#D7F5FA] to-white"
      ></div>
      <img
        :src="ImageParty"
        alt=""
        loading="lazy"
        class="relative mt-6"
        :width="904"
        :height="414"
      />
    </div>
  </Modal>
</template>
